import React from 'react';
import Carousel from './Carousel';
import AchievementSection from '../pages/AchievementSection';
import CarBrandsSection from '../pages/CarBrandsSection';
import AboutUsSection from '../pages/AboutUsSection';
import AdventureSection from '../pages/AdventureSection';
import VehicleFleet from '../pages/VehicleFleet';
import WhyChooseUs from '../pages/WhyChooseUs';
import HowItWork from '../pages/HowItWork';
import TestimonialSection from '../pages/TestimonialSection';
import BlogSection from '../pages/BlogSection';




const HeroSection = () => {
  
  return (

    <div className="th-hero-wrapper hero-1" id="hero">
<Carousel/>
<AchievementSection/>
<CarBrandsSection/>
<AboutUsSection/>
<AdventureSection/>
{/* <VehicleFleet/> */}
<WhyChooseUs/>
<HowItWork/>
<TestimonialSection/>
<BlogSection/>
    </div>
  );
};

export default HeroSection;
